import React from 'react';
import {Link} from 'react-router-dom';

function MichassContact() {
	return (
		<div className="flex flex-col w-full">
			<div className="flex items-center" id="breadcrumb-bg">
				<div className="w-full flex flex-wrap pl-8">
					<Link to="/" className="flex flex-wrap items-center text-purple-700">
						<svg class="w-[24px] h-[24px]" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
							<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m4 12 8-8 8 8M6 10.5V19a1 1 0 0 0 1 1h3v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h3a1 1 0 0 0 1-1v-8.5"/>
						</svg>
						<span>Accueil</span>
					</Link>
					<span className="mx-2 text-gray-400">/</span>
					<span className="flex flex-wrap items-center text-gray-600">Contacts</span>
				</div>
			</div>
			<div className="flex justify-center mx-24">
				<img className="my-12" src="img/page-en-construction.png" alt="page-en-construction" />
			</div>			
		</div>
	);
}

export default MichassContact;
